import { getStore, postStore } from '@/utils/http/http'
import { VZAN_STORE_BASE_URL, LIVEPAY_URL } from '@/utils/http/baseUrl'
// model
import StoreController from '../view/store/store.controller'

// 请求方法封装对象
const storeManagerApi = {
  /**
   * @method POST-获取门店代理列表
   * @param {Integer} storeId 门店id
   * @param {Integer} zbId 直播id
   */
  getStoreAgentList(params) {
    return postStore(
      VZAN_STORE_BASE_URL + '/health/v1/h5/store/manager/pageStoreAgent',
      params,
      false,
      StoreController.apiHeaderConfig()
    )
  },
  /**
   * @method POST-负责人门店列表数据
   * @param {Integer} storeId 门店id
   */
  getDirectorStoreList(params) {
    return postStore(
      VZAN_STORE_BASE_URL + `/health/v1/h5/store/auth/directorStoreList`,
      params,
      false,
      StoreController.apiHeaderConfig()
    )
  },
  /**
   * @method POST-H5客户管理-解绑-换绑代理
   * @param {Integer} storeId 门店id
   */
  customerManageOperateByStore(params) {
    return postStore(
      VZAN_STORE_BASE_URL +
        '/health/v1/h5/store/manager/customerManageOperateByStore',
      params,
      false,
      StoreController.apiHeaderConfig()
    )
  },
  /**
   * @method POST-H5获取观看直播列表
   * @param {Integer} storeId 门店id
   */
  watchRecord(params) {
    return postStore(
      VZAN_STORE_BASE_URL + '/health/v1/h5/store/manager/pageFollowUp',
      params,
      false,
      StoreController.apiHeaderConfig()
    )
  },
  /**
   * @method POST-获取当前门店信息
   * @param {Integer} storeId 门店id
   */
  getCurrentStoreInfo(params) {
    return getStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/getCurrentStoreInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-获取当前连连信息
   * @param {Integer} storeId 门店id
   */
  getUserAccInfo(params) {
    return postStore(
      `${LIVEPAY_URL}/LianLian/api/GetUserAccInfo`,
      params,
      false
    )
  },

  /**
   * @method POST-门店系统客户列表
   * @param {Integer} storeId 门店id
   * @param {Array[Integer]} agentIds 代理id集合
   */
  getCustomerManageInfoByStore(params) {
    return postStore(
      VZAN_STORE_BASE_URL +
        '/health/v1/h5/store/manager/getCustomerManageInfoByStore',
      params,
      false
    )
  },
}

// 命名导出所有方法
export const {
  getStoreAgentList,
  getDirectorStoreList,
  customerManageOperateByStore,
  watchRecord,
  getCurrentStoreInfo,
  getUserAccInfo,
  getCustomerManageInfoByStore,
} = storeManagerApi

// 默认导出封装对象
export default storeManagerApi
